import styled from "styled-components";

export const JetonStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.05);
  background-color: #fff;
  /* padding: 2px 10px; */
  margin: 10px 0;
`;
export const AmountStyled = styled.div`
  border-radius: 12px 12px 0 0;
  background-color:${(props) =>
    props.color === false ? "#ed5565" : "#48cfad"};
  width: 100%;
  text-align: center;
  color: #fff;
  padding: 10px;
  font-weight: 999;
  font-size:16px;
`;
export const BalanceStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
  margin: 5px 0;
  font-size:14px;
`;
export const InsertedDateStyled = styled.div`
  background-color: rgba(53, 58, 80, 0.1);
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 10px;
  width: 93%;
  text-align: center;
`;
export const DescriptionStyled = styled.div`
  width: 100%;
  text-align: right;
  padding: 2px 20px;
  margin-bottom: 10px;
  font-weight: 999;
  font-size: 12px;
`;
